<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-toolbar-title class="font-weight-black primary--text"
            >Análisis de Total Ganado</v-toolbar-title
          >

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> sim_card_download </v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>
        </v-app-bar>
        <v-sheet
          class="overflow-y-auto"
          :max-height="windowHeigth + this.auxHeigth"
        >
          <div class="container">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  outlined
                  dense
                  ref="id_presupuesto"
                  v-model="id_presupuesto"
                  @change="mostrarPeriodos"
                  :items="presupuestoList"
                  :error-messages="errorMessages"
                  item-text="descripcion"
                  item-value="id"
                  label="Presupuesto"
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-show="id_presupuesto != ''">
              <v-col cols="12" sm="12" md="12">
                <v-slider
                  v-model="periodo"
                  :thumb-size="50"
                  :tick-labels="ticksLabels"
                  :max="23"
                  step="1"
                  track-color="green"
                  thumb-label="always"
                  color="blue"
                  tick-size="4"
                  label="Real  -  Presupuestado"
                >
                  <template v-slot:thumb-label="{ value }">
                    {{ periodos[value] }}
                  </template>
                </v-slider>
                <v-btn small color="primary" @click="listar()" :loading="load">
                  Generar Reporte
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <div v-show="boolReporte">
            <v-data-table
              dense
              fixed-header
              :height="windowHeigth - 320 + auxHeigth"
              :headers="headers"
              :items="dtTotalGando"
              :items-per-page="2"
              sort-by="codigo"
              class="elevation-1"
              :loading="!dtTotalGando.length"
              loading-text="Cargando... Espere por favor"
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'items-per-page-options': [-1, 50, 100, 200],
              }"
            >
              <template v-slot:[`item.opciones`]="{ item }">
                <v-btn x-small text dark color="primary" @click="editar(item)">
                  <v-icon x-small>edit</v-icon>
                </v-btn>
              </template>

              <template v-slot:[`header.haber_basico_ant_enero`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template
                v-slot:[`header.haber_basico_ant_febrero`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template v-slot:[`header.haber_basico_ant_marzo`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.haber_basico_ant_abril`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.haber_basico_ant_mayo`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.haber_basico_ant_junio`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.haber_basico_ant_julio`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template
                v-slot:[`header.haber_basico_ant_agosto`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_ant_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_ant_octubre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_ant_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_ant_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template v-slot:[`header.haber_basico_act_enero`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template
                v-slot:[`header.haber_basico_act_febrero`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template v-slot:[`header.haber_basico_act_marzo`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.haber_basico_act_abril`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.haber_basico_act_mayo`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.haber_basico_act_junio`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.haber_basico_act_julio`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template
                v-slot:[`header.haber_basico_act_agosto`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_act_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_act_octubre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_act_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.haber_basico_act_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_enero`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_febrero`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_marzo`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_abril`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_mayo`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_junio`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_julio`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_agosto`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_octubre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_ant_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_enero`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_febrero`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_marzo`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_abril`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_mayo`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_junio`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_julio`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_agosto`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_octubre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.bono_antiguedad_act_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template v-slot:[`header.comisiones_ant_enero`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_febrero`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_marzo`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_abril`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_mayo`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_junio`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_julio`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.comisiones_ant_agosto`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template
                v-slot:[`header.comisiones_ant_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template v-slot:[`header.comisiones_ant_octubre`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template
                v-slot:[`header.comisiones_ant_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.comisiones_ant_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template v-slot:[`header.comisiones_act_enero`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_febrero`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_marzo`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_abril`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_mayo`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_junio`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_julio`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.comisiones_act_agosto`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template
                v-slot:[`header.comisiones_act_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template v-slot:[`header.comisiones_act_octubre`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template
                v-slot:[`header.comisiones_act_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.comisiones_act_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_enero`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_febrero`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_marzo`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_abril`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_mayo`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_junio`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_julio`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_agosto`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_octubre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_ant_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_enero`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_febrero`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_marzo`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_abril`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_mayo`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_junio`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_julio`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_agosto`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_octubre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.otros_ingresos_act_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template v-slot:[`header.total_ganado_ant_enero`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template
                v-slot:[`header.total_ganado_ant_febrero`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template v-slot:[`header.total_ganado_ant_marzo`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.total_ganado_ant_abril`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.total_ganado_ant_mayo`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.total_ganado_ant_junio`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.total_ganado_ant_julio`]="{ header }">{{
                header.text.replace(" Anterior ", "  ") + " " + gestionAnt
              }}</template>
              <template
                v-slot:[`header.total_ganado_ant_agosto`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_ant_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_ant_octubre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_ant_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_ant_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Anterior ", "  ") + " " + gestionAnt
                }}</template
              >
              <template v-slot:[`header.total_ganado_act_enero`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template
                v-slot:[`header.total_ganado_act_febrero`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template v-slot:[`header.total_ganado_act_marzo`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.total_ganado_act_abril`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.total_ganado_act_mayo`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.total_ganado_act_junio`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template v-slot:[`header.total_ganado_act_julio`]="{ header }">{{
                header.text.replace(" Actual ", "  ") + " " + gestionAct
              }}</template>
              <template
                v-slot:[`header.total_ganado_act_agosto`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_act_septiembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_act_octubre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_act_noviembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template
                v-slot:[`header.total_ganado_act_diciembre`]="{ header }"
                >{{
                  header.text.replace(" Actual ", "  ") + " " + gestionAct
                }}</template
              >
              <template v-slot:[`header.total_ant`]="{ header }">{{
                header.text.replace(" Anterior", " ") + " " + gestionAnt
              }}</template>
              <template v-slot:[`header.total_act`]="{ header }">{{
                header.text.replace(" Actual", " ") + " " + gestionAct
              }}</template>

              <template v-slot:[`item.estado`]="{ item }">
                <div v-if="item.estado == 'I'">
                  <v-btn
                    color="error"
                    x-small
                    text
                    dark
                    @click="abrirDialogActivacion(item)"
                  >
                    <v-icon x-small>block</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn
                    color="success"
                    x-small
                    text
                    dark
                    @click="abrirDialogActivacion(item)"
                  >
                    <v-icon x-small>check</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:[`item.centro_costo`]="{ item }">
                <div v-if="item.centro_costo == null" class="error--text">
                  NO DEFINIDO
                </div>
                <div v-else>
                  {{ item.centro_costo }}
                </div>
              </template>
              <template v-slot:[`item.area`]="{ item }">
                <div v-if="item.area == 'NO DEFINIDO'" class="error--text">
                  {{ item.area }}
                </div>
                <div v-else>
                  {{ item.area }}
                </div>
              </template>

              <template v-slot:[`item.subarea`]="{ item }">
                <div v-if="item.subarea == 'NO DEFINIDO'" class="error--text">
                  {{ item.subarea }}
                </div>
                <div v-else>
                  {{ item.subarea }}
                </div>
              </template>

              <template v-slot:no-data>
                <v-btn color="primary" @click="listar">Reset</v-btn>
              </template>
            </v-data-table>
          </div>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogActivacion" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogActivacion = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog dense v-model="dialogCentroCosto" max-width="500px">
        <v-card ref="formCentroCosto">
          <v-card-title>
            <span class="headline">Datos Centro de Costo</span>
          </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogBorrarCentroCosto" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción borrará la asignación de Centro de Costo al
            cargo.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBorrarCentroCosto = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="eliminarCentroCosto()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      //Declaración de arrays
      dtTotalGando: [],
      dtCentroCostos: [],
      areaList: [],
      presupuestoList: [],
      boolReporte: false,
      ex1: { label: "color", val: 25, color: "orange darken-3" },

      value: 0,
      periodo: 18,
      periodos: [],
      slider: 10,
      usuario: this.$store.state.usuario.user,
      ticksLabels: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],

      //Declaración de variables de Dialog
      dialogForm: false,
      dialogCargaExcel: false,
      dialogActivacion: false,
      dialogCentroCosto: false,
      dialogBorrarCentroCosto: false,
      //Declaración de variables de formulario
      id: "",
      codigo: "",
      descripcion: "",
      salario_ref: "",
      id_presupuesto: "",
      id_area: "",
      id_subarea: "",
      id_area_presupuesto: "",
      estado: "",
      porcentajeCco: "",
      porcentaje: 100,
      id_centro_costo: "",
      gestionAnt: 1999,
      gestionAct: 2000,
      load: false,

      file: null,
      //Declaración de variables de tabla
      headers: [
        {
          text: "Área",
          value: "area",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Subarea",
          value: "subarea",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Area del presupuesto",
          value: "area_presupuesto",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre Completo",
          value: "nombre_completo",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Cenco",
          value: "centro_costo",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Equipo",
          value: "equipo",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha de Ingreso",
          value: "fecha_ingreso",
          filter: this.searchParamDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha de Salida",
          value: "fecha_salida",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: " Haber Básico Anterior Enero",
          value: "haber_basico_ant_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Febrero",
          value: "haber_basico_ant_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Marzo",
          value: "haber_basico_ant_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Abril",
          value: "haber_basico_ant_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Mayo",
          value: "haber_basico_ant_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Junio",
          value: "haber_basico_ant_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Julio",
          value: "haber_basico_ant_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Agosto",
          value: "haber_basico_ant_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Septiembre",
          value: "haber_basico_ant_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Octubre",
          value: "haber_basico_ant_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Noviembre",
          value: "haber_basico_ant_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Anterior Diciembre",
          value: "haber_basico_ant_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Actual Enero",
          value: "haber_basico_act_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Actual Febrero",
          value: "haber_basico_act_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Actual Marzo",
          value: "haber_basico_act_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          sortable: false,
        },
        {
          text: " Haber Básico Actual Abril",
          value: "haber_basico_act_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Mayo",
          value: "haber_basico_act_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Junio",
          value: "haber_basico_act_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Julio",
          value: "haber_basico_act_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Agosto",
          value: "haber_basico_act_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Septiembre",
          value: "haber_basico_act_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Octubre",
          value: "haber_basico_act_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Noviembre",
          value: "haber_basico_act_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: " Haber Básico Actual Diciembre",
          value: "haber_basico_act_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Enero",
          value: "bono_antiguedad_ant_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Febrero",
          value: "bono_antiguedad_ant_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Marzo",
          value: "bono_antiguedad_ant_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Abril",
          value: "bono_antiguedad_ant_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Mayo",
          value: "bono_antiguedad_ant_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Junio",
          value: "bono_antiguedad_ant_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Julio",
          value: "bono_antiguedad_ant_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Agosto",
          value: "bono_antiguedad_ant_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Septiembre",
          value: "bono_antiguedad_ant_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Octubre",
          value: "bono_antiguedad_ant_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Noviembre",
          value: "bono_antiguedad_ant_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Anterior Diciembre",
          value: "bono_antiguedad_ant_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Enero",
          value: "bono_antiguedad_act_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Febrero",
          value: "bono_antiguedad_act_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Marzo",
          value: "bono_antiguedad_act_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Abril",
          value: "bono_antiguedad_act_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Mayo",
          value: "bono_antiguedad_act_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Junio",
          value: "bono_antiguedad_act_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Julio",
          value: "bono_antiguedad_act_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Agosto",
          value: "bono_antiguedad_act_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Septiembre",
          value: "bono_antiguedad_act_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Octubre",
          value: "bono_antiguedad_act_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Noviembre",
          value: "bono_antiguedad_act_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Bono Antiguedad Actual Diciembre",
          value: "bono_antiguedad_act_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Enero",
          value: "comisiones_ant_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Febrero",
          value: "comisiones_ant_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Marzo",
          value: "comisiones_ant_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Abril",
          value: "comisiones_ant_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Mayo",
          value: "comisiones_ant_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Junio",
          value: "comisiones_ant_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Julio",
          value: "comisiones_ant_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Agosto",
          value: "comisiones_ant_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Septiembre",
          value: "comisiones_ant_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Octubre",
          value: "comisiones_ant_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Noviembre",
          value: "comisiones_ant_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Anterior Diciembre",
          value: "comisiones_ant_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Enero",
          value: "comisiones_act_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Febrero",
          value: "comisiones_act_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Marzo",
          value: "comisiones_act_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Abril",
          value: "comisiones_act_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Mayo",
          value: "comisiones_act_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Junio",
          value: "comisiones_act_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Julio",
          value: "comisiones_act_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Agosto",
          value: "comisiones_act_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Septiembre",
          value: "comisiones_act_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Octubre",
          value: "comisiones_act_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Noviembre",
          value: "comisiones_act_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Comisiones Actual Diciembre",
          value: "comisiones_act_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Enero",
          value: "otros_ingresos_ant_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Febrero",
          value: "otros_ingresos_ant_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Marzo",
          value: "otros_ingresos_ant_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Abril",
          value: "otros_ingresos_ant_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Mayo",
          value: "otros_ingresos_ant_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Junio",
          value: "otros_ingresos_ant_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Julio",
          value: "otros_ingresos_ant_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Agosto",
          value: "otros_ingresos_ant_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Septiembre",
          value: "otros_ingresos_ant_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Octubre",
          value: "otros_ingresos_ant_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Noviembre",
          value: "otros_ingresos_ant_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Anterior Diciembre",
          value: "otros_ingresos_ant_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Enero",
          value: "otros_ingresos_act_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Febrero",
          value: "otros_ingresos_act_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Marzo",
          value: "otros_ingresos_act_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Abril",
          value: "otros_ingresos_act_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Mayo",
          value: "otros_ingresos_act_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Junio",
          value: "otros_ingresos_act_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Julio",
          value: "otros_ingresos_act_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Agosto",
          value: "otros_ingresos_act_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Septiembre",
          value: "otros_ingresos_act_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Octubre",
          value: "otros_ingresos_act_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Noviembre",
          value: "otros_ingresos_act_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Otros Ingresos Actual Diciembre",
          value: "otros_ingresos_act_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Enero",
          value: "total_ganado_ant_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Febrero",
          value: "total_ganado_ant_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Marzo",
          value: "total_ganado_ant_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Abril",
          value: "total_ganado_ant_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Mayo",
          value: "total_ganado_ant_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Junio",
          value: "total_ganado_ant_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Julio",
          value: "total_ganado_ant_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Agosto",
          value: "total_ganado_ant_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Septiembre",
          value: "total_ganado_ant_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Octubre",
          value: "total_ganado_ant_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Noviembre",
          value: "total_ganado_ant_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Anterior Diciembre",
          value: "total_ganado_ant_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Enero",
          value: "total_ganado_act_enero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Febrero",
          value: "total_ganado_act_febrero",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Marzo",
          value: "total_ganado_act_marzo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Abril",
          value: "total_ganado_act_abril",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Mayo",
          value: "total_ganado_act_mayo",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Junio",
          value: "total_ganado_act_junio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Julio",
          value: "total_ganado_act_julio",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Agosto",
          value: "total_ganado_act_agosto",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Septiembre",
          value: "total_ganado_act_septiembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Octubre",
          value: "total_ganado_act_octubre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Noviembre",
          value: "total_ganado_act_noviembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Ganado Actual Diciembre",
          value: "total_ganado_act_diciembre",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Anterior",
          value: "total_ant",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
        {
          text: "Total Actual",
          value: "total_act",
          align: "right",
          class: "primary white--text text-subtitle-2",
          sortable: false,
        },
      ],

      searchParamCodigo: "",
      searchParamDescripcion: "",
      esEditado: false,
      editarCodigo: false,
      editarCodigoCentroCosto: false,
      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,

      //variables de errrores
      valida: 0,
      errorMessages: "",
      errorMessagesCentroCosto: "",
      error: "",
      //variables de tamaño de pantalla

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight + this.auxHeigth,
      auxWidth: 0,
      auxHeigth: 0,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        salario_ref: this.salario_ref,
        id_area: this.id_area,
        id_subarea: this.id_subarea,
        id_area_presupuesto: this.id_area_presupuesto,
      };
    },
    formCentroCosto() {
      return {
        id_centro_costo: this.id_centro_costo,
        porcentaje: this.porcentaje,
      };
    },
  },

  watch: {
    dialogForm(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesCentroCosto = "";
    },
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')

    this.$store.dispatch("actualizarTitulo", "Análisis de Total Ganado");

    this.selectPresupuesto();
    this.selectAreaPresup();
    this.selectCentroCosto();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    listar() {
      let me = this;
      me.boolReporte = true;
      me.dtTotalGando = [];
      me.load = true;
      axios
        .get(
          "api/reportes/listarVistaRepTotalGanado/" +
            me.id_presupuesto +
            "/" +
            me.periodo
        )
        .then(function (response) {
          me.dtTotalGando = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight + me.auxHeigth;
          me.load = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarPeriodos() {
      let me = this;
      var aux;
      var arreglo;
      me.boolReporte = false;
      axios
        .get("api/reportes/gestionActual/" + me.id_presupuesto)
        .then(function (response) {
          aux = response.data;
          arreglo = aux.split(",");

          me.gestionAct = arreglo[0];
          me.gestionAnt = arreglo[1];
        })
        .catch(function (error) {
          console.log(error);
        });

      axios
        .get("api/reportes/mostrarGestiones/" + me.id_presupuesto)
        .then(function (response) {
          aux = response.data;
          me.periodos = aux.split(",");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarCargoCentro() {
      let me = this;
      axios
        .get("api/cargo_centros/listarCargoCentro/" + this.id)
        .then(function (response) {
          me.mostrarPorcentaje();
          me.dtCentroCostos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarPorcentaje() {
      let me = this;
      axios
        .get("api/cargo_centros/mostarPorcentaje/" + this.id)
        .then(function (response) {
          me.porcentajeCco = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectSubarea() {
      let me = this;
      axios
        .get("api/subareas/select/" + this.id_area)
        .then(function (response) {
          me.subareaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.areaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectAreaPresup() {
      let me = this;
      axios
        .get("api/area_presupuestos/select")
        .then(function (response) {
          me.areaPresupList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCentroCosto() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.CentroCostosList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectPresupuesto() {
      let me = this;
      axios
        .get("api/presupuestos/select")
        .then(function (response) {
          me.presupuestoList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogActivacion = true;
      this.estado = item.estado;
    },

    mostrarBusqueda() {
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },
    closeCentroCosto() {
      this.dialogCentroCosto = false;
      this.limpiarCentroCosto();
    },
    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.salario_ref = item.salario_ref;
      this.id_area = item.id_area;
      this.id_subarea = item.id_subarea;
      this.id_area_presupuesto = item.id_area_presupuesto;
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogForm = true;
      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada

      this.selectSubarea();
      this.listarCargoCentro();
    },
    agregar() {
      this.editarCodigo = true;
      this.dialogForm = true;
    },
    agregarCentroCosto() {
      this.editarCodigoCentroCosto = true;
      this.dialogCentroCosto = true;
    },

    cerrar() {
      this.dialogForm = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.salario_ref = "";
      this.id_area = "";
      this.id_subarea = "";
      this.id_area_presupuesto = "";
      this.esEditado = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarCentroCosto(item) {
      this.id_centro_costo = "";
      this.id_cargo = "";
      this.porcentaje = 100;
      this.editedIndexCco = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/cargos/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,
            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/cargos/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,
            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    exportarExcel() {
      let me = this;
      var auxString = JSON.stringify(me.dtTotalGando);

      auxString = auxString.replace(/_ant_/g, " " + me.gestionAnt + " ");
      auxString = auxString.replace(/_act_/g, " " + me.gestionAct + " ");
      auxString = auxString.replace(/_/g, " ");
      var auxJson = JSON.parse(auxString);

      try {
        json2excel({
          data: auxJson,
          name: "Análisis de Total Gando",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/cargos/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.cerrarCarga();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarCentroCosto() {
      this.validaCentroCosto = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formCentroCosto).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaCentroCosto += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaCentroCosto += 1;
        }
      });
      return this.validaCentroCosto;
    },

    activar() {
      let me = this;
      axios
        .put("api/cargos/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/cargos/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteItemCentroCosto(item) {
      this.id_centro_costo = item.id_centro_costo;
      this.dialogBorrarCentroCosto = true;
    },
    eliminarCentroCosto() {
      let me = this;

      axios
        .delete(
          "api/cargo_centros/EliminarCargoCentro/" +
            me.id +
            "/" +
            me.id_centro_costo,
          {}
        )
        .then(function (response) {
          me.listarCargoCentro();
          me.$store.dispatch("setSnackbar", {
            text: "Centro de Costo eliminado exitosamente.",
            color: "success",
          });
          me.dialogBorrarCentroCosto = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarCentroCosto() {
      if (this.validarCentroCosto() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/cargo_centros/actualizar", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoCentro();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/cargo_centros/crear", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoCentro();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    filtroCodigo(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamCodigo) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value.toLowerCase().includes(this.searchParamCodigo.toLowerCase());
    },
    filtroDescripcion(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamDescripcion) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value
        .toLowerCase()
        .includes(this.searchParamDescripcion.toLowerCase());
    },
  },
};
</script>
